import { FunkrundsteuerEmpfaengerAbregelmoeglichkeit } from './funkrundsteuer-empfaenger-abregelmoeglichkeit.model';

export enum Regelstufe {
    RS_100_TO_0 = '100,90,80,70,60,50,40,30,20,10,0',
    RS_100_60_30_0 = '100,60,30,0',
    RS_100_60_0 = '100,60,0',
    RS_100_30_0 = '100,30,0',
    RS_100_0 = '100,0',
    RS_100_100 = '100,100',
    RS_70_70 = '70,70',
}

export class RegelstufeItem {

    public key: Regelstufe;
    public description: string;
    public order: number;

    constructor(key: Regelstufe, description: string, order: number) {
        this.key = key;
        this.description = description;
        this.order = order;
    }

    public static getAll(): RegelstufeItem[] {
        return [
            new RegelstufeItem(Regelstufe.RS_100_TO_0, Regelstufe.RS_100_TO_0, 0),
            new RegelstufeItem(Regelstufe.RS_100_60_30_0, Regelstufe.RS_100_60_30_0, 1),
            new RegelstufeItem(Regelstufe.RS_100_60_0, Regelstufe.RS_100_60_0, 2),
            new RegelstufeItem(Regelstufe.RS_100_30_0, Regelstufe.RS_100_30_0, 3),
            new RegelstufeItem(Regelstufe.RS_100_0, Regelstufe.RS_100_0, 4),
            new RegelstufeItem(Regelstufe.RS_100_100, Regelstufe.RS_100_100, 5),
            new RegelstufeItem(Regelstufe.RS_70_70, Regelstufe.RS_70_70, 6),
        ].sort(this.sortByOrder);
    }

    public static getAllForAbregelmoeglichkeit(abregelmoeglichkeit: FunkrundsteuerEmpfaengerAbregelmoeglichkeit | undefined): RegelstufeItem[] {
        const all = this.getAll().sort(this.sortByOrder);
        switch (abregelmoeglichkeit) {
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.KEINE:
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FALLBACK_PROCESS_BY_PHONE:
                return all.filter(value => value.key === Regelstufe.RS_100_100);
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FIX70:
                return all.filter(value => value.key === Regelstufe.RS_70_70);
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FRE:
                return all.filter(value => [
                    Regelstufe.RS_100_60_30_0,
                    Regelstufe.RS_100_60_0,
                    Regelstufe.RS_100_30_0,
                    Regelstufe.RS_100_0,
                ].indexOf(value.key) !== -1);
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.FWA:
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.TASE2:
            case FunkrundsteuerEmpfaengerAbregelmoeglichkeit.IEC101_104:
                return all.filter(value => [
                    Regelstufe.RS_100_TO_0,
                    Regelstufe.RS_100_60_30_0,
                    Regelstufe.RS_100_60_0,
                    Regelstufe.RS_100_30_0,
                    Regelstufe.RS_100_0,
                ].indexOf(value.key) !== -1);
            default:
                return all;

        }
    }

    private static sortByOrder(a: RegelstufeItem, b: RegelstufeItem): number {
        return a.order - b.order;
    }

}

